import { Component, input } from '@angular/core';
import {
  EdgeLabelPosition,
  NgDiagramBaseEdgeComponent,
  NgDiagramBaseEdgeLabelComponent,
  type Edge,
  type NgDiagramEdgeTemplate,
} from 'ng-diagram';

type LabelEdgeDataType = {
  label: string;
  type: string;
};
@Component({
  standalone: true,
  imports: [NgDiagramBaseEdgeComponent, NgDiagramBaseEdgeLabelComponent],
  templateUrl: './avsEdge.html',
  styleUrls: ['./avsEdge.scss'],
})
export class AvsEdgeComponent implements NgDiagramEdgeTemplate<LabelEdgeDataType> {
  edge = input.required<Edge<LabelEdgeDataType>>();
}